import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth.service';
import { LoaderService } from '../../loader.service';
import { AlertDialogService } from '../../shared/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from '../../shared/confirm-dialog/confirm-dialog.service';
import { SubscriptionService } from '../subscription.service';
import { AuthzAccessHintService } from '../../shared/authz-access-hint/authz-access-hint.service';
import { AUTHZ_FEATURES } from '../../constants/permissions';
import { permissionsForFeature } from '../../utils/permission.utils';
var ConfigRequestViewComponent = /** @class */ (function () {
    function ConfigRequestViewComponent(route, subscriptionService, authService, loaderService, dialogService, alertDialogService, authzAccessHintService) {
        this.route = route;
        this.subscriptionService = subscriptionService;
        this.authService = authService;
        this.loaderService = loaderService;
        this.dialogService = dialogService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.kind = 'subscription';
        this.approvalPermission = '';
        this.feature = 'subscription';
        this.canDecide = false;
        this.authzAccessHint = null;
        this.isOwnRequest = false;
        this.request = null;
        this.rule = {};
        this.loadError = '';
        this.raw = null;
        this.userEmail = '';
    }
    ConfigRequestViewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, permissions, _a, user;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = this.route.snapshot.data || {};
                        this.kind = data.kind || 'subscription';
                        this.feature = data.feature || (this.kind === 'billingPlan' ? AUTHZ_FEATURES.BILLING_PLANS : AUTHZ_FEATURES.SUBSCRIPTION);
                        permissions = permissionsForFeature(this.feature, this.authService.getAuthzPanels()) || {};
                        this.approvalPermission = permissions.approve || '';
                        this.canDecide = this.authService.isAuthorizedFor(this.approvalPermission, this.feature);
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData(this.feature)];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [4 /*yield*/, this.authService.getUserDetails().toPromise()];
                    case 2:
                        user = _b.sent();
                        this.userEmail = String((user && user.email) || '').trim().toLowerCase();
                        return [4 /*yield*/, this.load()];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ConfigRequestViewComponent.prototype, "isPending", {
        get: function () {
            return this.request && String(this.request.requestStatus).toUpperCase() === 'PENDING';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigRequestViewComponent.prototype, "showApprovedBy", {
        get: function () {
            if (!this.request) {
                return false;
            }
            var status = String(this.request.requestStatus || '').toUpperCase();
            return status === 'APPROVED' || status === 'REJECTED';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigRequestViewComponent.prototype, "approvedByLabel", {
        get: function () {
            var status = String((this.request && this.request.requestStatus) || '').toUpperCase();
            return status === 'REJECTED' ? 'Rejected By' : 'Approved By';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigRequestViewComponent.prototype, "title", {
        get: function () {
            if (this.kind === 'billingPlan') {
                return "ACCESS FEE REQUEST: " + ((this.request && this.request.name) || '');
            }
            return "SUBSCRIPTION REQUEST: " + ((this.request && this.request.name) || '');
        },
        enumerable: true,
        configurable: true
    });
    ConfigRequestViewComponent.prototype.displayOrNA = function (value) {
        return value == null || value === '' ? '--' : value;
    };
    ConfigRequestViewComponent.prototype.decide = function (action) {
        var _this = this;
        if (action === 'approve' && this.isOwnRequest) {
            return;
        }
        var label = action === 'approve' ? 'Approve' : 'Reject';
        this.dialogService.open({
            title: label,
            message: label + " this request?",
            cancelText: 'Cancel',
            confirmText: label
        });
        this.dialogService.confirmed().subscribe(function (confirmed) {
            if (!confirmed) {
                return;
            }
            _this.loaderService.openLoading();
            _this.subscriptionService.decideConfigRequest(_this.request._id, action, _this.kind).subscribe(function (response) {
                _this.loaderService.closeLoading();
                var successMessage = action === 'reject'
                    ? 'Request rejected successfully'
                    : ((response && response.message) || 'Request approved successfully');
                _this.alert(label, successMessage);
                var status = action === 'approve' ? 'APPROVED' : 'REJECTED';
                if (_this.raw) {
                    _this.raw.requestStatus = status;
                }
                if (_this.request) {
                    _this.request.requestStatus = status;
                }
            }, function (error) {
                _this.loaderService.closeLoading();
                _this.alert(label, _this.errorMessage(error));
            });
        });
    };
    ConfigRequestViewComponent.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestId, _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestId = this.route.snapshot.paramMap.get('id');
                        this.loaderService.openLoading();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.subscriptionService.getConfigRequestById(requestId, this.kind).toPromise()];
                    case 2:
                        _a.raw = _b.sent();
                        this.request = this.raw;
                        this.rule = (this.request && this.request.entity) || {};
                        this.isOwnRequest = this.isCreatedByCurrentUser(this.request && this.request.createdBy);
                        this.loadError = '';
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.request = null;
                        this.raw = null;
                        this.loadError = this.errorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.loaderService.closeLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigRequestViewComponent.prototype.isCreatedByCurrentUser = function (createdBy) {
        if (!this.userEmail || !createdBy) {
            return false;
        }
        return String(createdBy).trim().toLowerCase() === this.userEmail;
    };
    ConfigRequestViewComponent.prototype.errorMessage = function (error) {
        var body = error && error.error;
        if (body && (body.message || body.errorMessage)) {
            return body.message || body.errorMessage;
        }
        return 'Request failed';
    };
    ConfigRequestViewComponent.prototype.alert = function (title, message) {
        this.alertDialogService.open({ title: title, message: message, confirmText: 'OK' });
    };
    return ConfigRequestViewComponent;
}());
export { ConfigRequestViewComponent };
